import { useQuery } from '@tanstack/react-query';
import { getWindmillFlowsApi } from '../utils/apis';

export const useWindmillFlows = () => {
  const { data, isLoading, error, isError } = useQuery({
    queryKey: ['windmill-flows'],
    queryFn: getWindmillFlowsApi,
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: 2,
  });

  return {
    flows: data?.data || [],
    isLoading,
    error,
    isError,
  };
};
